import { useCallback, useEffect, useRef } from 'react'

export default function useTimeout(callback: () => void, delay: number) {
  const callbackRef = useRef(callback)

  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  const set = useCallback(() => {
    if (timeoutRef.current !== null) {
      clearTimeout(timeoutRef.current)
    }
    timeoutRef.current = setTimeout(() => callbackRef.current(), delay)
  }, [delay])

  const clear = useCallback(() => {
    if (timeoutRef.current !== null) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }
  }, [])

  useEffect(() => {
    set()

    return clear
  }, [delay, set, clear])

  const reset = useCallback(() => {
    clear()

    set()
  }, [clear, set])

  return { reset, clear }
}
